module.exports = __webpack_public_path__ + "f6a193c92fa4564cd4c7d9ac86578edd.svg";